export default {"background":null,"foreground":null}